function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Field } from 'formik';
import config from 'react-global-configuration';
import { useTranslation } from 'react-i18next';
var WebformCaptcha = function WebformCaptcha(props) {
  var entity = props.entity,
    customClasses = props.customClasses,
    errors = props.errors,
    touched = props.touched;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var key = entity.get('#webform_key');
  var recaptchaSiteKey = config.get('RECAPTCHA_SITE_KEY') || '';
  var webformKey = entity.get('#webform_key');
  var requiredError = entity.get('#required_error');
  if (recaptchaSiteKey === '') {
    console.error('RECAPTCHA_SITE_KEY missing');
    if (process.env.REACT_APP_ENV !== 'production') {
      return /*#__PURE__*/React.createElement("div", null, "RECAPTCHA_SITE_KEY missing");
    } else {
      return null;
    }
  }
  var validation = function validation(value) {
    if (!value) {
      return requiredError || t(['webform.components.address_autocomplete.required', 'webform.required', 'webform_required']);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "WebformCaptcha"
  }, /*#__PURE__*/React.createElement(Field, {
    required: true,
    name: key,
    validate: validation,
    className: "FormElement"
  }, function (_ref) {
    var field = _ref.field,
      form = _ref.form;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({}, field, {
      type: "hidden"
    })), /*#__PURE__*/React.createElement(ReCAPTCHA, {
      sitekey: recaptchaSiteKey,
      onChange: function onChange(e) {
        form.setFieldValue(webformKey, e);
        form.setFieldValue('g-recaptcha-response', e);
      }
    }), errors[webformKey] && touched[webformKey] ? /*#__PURE__*/React.createElement("div", {
      className: "FormElement__error WebformCaptcha_error WebformComponent--error"
    }, errors[webformKey]) : null);
  }));
};
export default WebformCaptcha;